module.exports = __webpack_public_path__ + "img/ari.92d64f27.png";